import { graphql } from '../../gql';

export const PRODUCT_IMAGE_FILE_FRAGMENT = graphql(`
  fragment ProductImageFile on ProductImageFile {
    id
    url
    thumbnailUrl
    altText
    width
    height
  }
`);

export const PRODUCT_IMAGE_FRAGMENT = graphql(`
  fragment ProductImage on ProductImage {
    id
    isFeatured
    order
    displayName
    isConnected
    createdAt
    image {
      ...ProductImageFile
    }
  }
`);

export const PRODUCT_VARIANT_OPTION_FRAGMENT = graphql(`
  fragment ProductVariantOption on ProductVariantOption {
    optionId
    value
  }
`);

export const PRODUCT_VARIANT_FRAGMENT = graphql(`
  fragment ProductVariant on ProductVariant {
    id
    productId
    price
    sku
    barcode
    variantOptions {
      ...ProductVariantOption
    }
    image {
      ...ProductImageFile
    }
    compareAtPrice
    trackQuantity
    quantityAdjustment
    quantity
    initialQuantity
    isNew
    weightUnit
    weight
    taxable
  }
`);

export const PRODUCT_OPTION_FRAGMENT = graphql(`
  fragment ProductOption on ProductOption {
    id
    name
    position
    values
  }
`);

export const DELIVERY_PROCESSING_TIME_FRAGMENT = graphql(`
  fragment DeliveryProcessingTime on DeliveryProcessingTime {
    min
    max
    unit
  }
`);

export const STANDARD_SHIPPING_FRAGMENT = graphql(`
  fragment StandardShipping on StandardShipping {
    domesticRate
    internationalRate
    countryOfOrigin
    processingTime {
      ...DeliveryProcessingTime
    }
  }
`);

export const PRODUCT_DATA_FRAGMENT = graphql(`
  fragment ProductData on ProductInfo {
    title
    description
    options {
      ...ProductOption
    }
    images {
      ...ProductImage
    }
    variants {
      ...ProductVariant
    }
    productType
    deliveryProfile {
      id
      name
    }
    standardShipping {
      ...StandardShipping
    }
  }
`);

export const PRODUCT_FIELDS_FRAGMENT = graphql(`
  fragment ProductFields on Product {
    id
    isDetatched
    idAlias
    current {
      ...ProductData
    }
    pending {
      ...ProductData
    }
    createdAt
    updatedAt
    createdBy
    updatedBy
    status
    reviewStatus
    rejectedReason
    # Fees as they apply to THIS product. The shop can override commission and
    # fees per product (admin-web has the editor for it), and the resolver
    # already layers product over seller over shop — but nothing asked for it,
    # so the editor's fees card read the seller's rate and told the seller a
    # number the order would not honour.
    settings {
      productFee {
        productFee
      }
      productPercentage {
        productPercentage
      }
      commissionBasis {
        basis
      }
    }
  }
`);

export const GET_PRODUCT_QUERY = graphql(`
  query Product($id: ID!) {
    product(id: $id) {
      ...ProductFields
    }
  }
`);

export const UPDATE_PRODUCT_MUTATION = graphql(`
  mutation UpdateProduct($product: ProductInput!, $disableProductUntilChangesApproved: Boolean) {
    updateProduct(product: $product, disableProductUntilChangesApproved: $disableProductUntilChangesApproved) {
      ...ProductFields
    }
  }
`);

export const CREATE_PRODUCT_MUTATION = graphql(`
  mutation CreateProduct($product: ProductInput!) {
    createProduct(product: $product) {
      ...ProductFields
    }
  }
`);

/**
 * Take a product out of the store.
 *
 * The mutation is named `deleteProduct`, but a product with any order behind it
 * is archived rather than removed, so the history survives — which is why the
 * screen calls the action Archive and says which of the two will happen.
 */
export const DELETE_PRODUCT_MUTATION = graphql(`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`);
